import { useNavigate } from "react-router-dom"
import {
  AgencyRoleEnum,
  BusinessRelationshipEnum,
  BusinessTypeEnum,
} from "~/__generated__/graphql"
import { useCurrentUser } from "~/auth/CurrentUserContext"
import { onboardingChoosePlanPath } from "~/common/paths"
import { useHomePath } from "~/common/useHomePath"
import { useSafeMutation } from "~/common/useSafeMutation"
import { UPDATE_USER_MUTATION } from "./api"

export const useOnCompleteOnboarding = () => {
  const navigate = useNavigate()
  const currentUser = useCurrentUser()
  const homePath = useHomePath()
  const [runUpdateUser] = useSafeMutation(UPDATE_USER_MUTATION)

  const onCompleteOnboarding = async () => {
    const { data, errors } = await runUpdateUser({
      variables: {
        input: {
          onboarded: true,
        },
      },
    })
    if (errors) {
      console.error(errors)
    } else if (data) {
      // Skip subscription selection for free agencies
      // Check both the agency's business relationship and the user's agency business relationship
      // (the latter is set at invite time and used before the agency is created)
      const isFreeAgency =
        currentUser.agency?.businessRelationship ===
          BusinessRelationshipEnum.Free ||
        currentUser.agencyBusinessRelationship === BusinessRelationshipEnum.Free
      // Talent agencies go straight onto the free Roster plan, which the
      // mutation above just provisioned, so they never see the picker (ZAN-893).
      const isTalentAgency =
        currentUser.agency?.businessType === BusinessTypeEnum.Talent ||
        currentUser.agencyBusinessType === BusinessTypeEnum.Talent
      if (
        currentUser.agencyRole === AgencyRoleEnum.AgencyAdmin &&
        !isFreeAgency &&
        !isTalentAgency
      ) {
        navigate(onboardingChoosePlanPath({}))
      } else {
        navigate(homePath)
      }
    } else {
      console.error("unexpected response", { data, errors })
    }
  }

  return { onCompleteOnboarding }
}
